import { parsePhoneNumberFromString } from 'libphonenumber-js'

export function normalizeE164(raw: string | null | undefined): string | null {
  if (!raw) return null
  const num = parsePhoneNumberFromString(raw, 'US')
  return num?.isValid() ? num.format('E.164') : null
}

/** US national numbers are exactly 10 digits. */
export const US_PHONE_DIGITS = 10

export const INCOMPLETE_PHONE_MESSAGE = 'Enter a full phone number.'

/** Digits of the national number, dropping formatting and the +1 country code. */
export function nationalPhoneDigits(raw: string | null | undefined): string {
  const trimmed = raw?.trim() ?? ''
  const digits = trimmed.replace(/\D/g, '')
  if (trimmed.startsWith('+1') || digits.length > US_PHONE_DIGITS) {
    return digits.startsWith('1') ? digits.slice(1) : digits
  }
  return digits
}

export function isCompletePhone(raw: string | null | undefined): boolean {
  return nationalPhoneDigits(raw).length === US_PHONE_DIGITS
}

/** Submit-time check. An empty optional number is fine; a partial one never is. */
export function validatePhone(
  raw: string | null | undefined,
  { required = false }: { required?: boolean } = {}
): string | undefined {
  if (!nationalPhoneDigits(raw)) return required ? INCOMPLETE_PHONE_MESSAGE : undefined
  return isCompletePhone(raw) ? undefined : INCOMPLETE_PHONE_MESSAGE
}
